import React, { useEffect } from 'react'
import { IDigitalHealthProfile } from '../../components/UI/SelectedSalesOrder/DigitalHealthProfileTab';
import { clearChat, setCurrentConversation } from '../../store/slices/chat';
import { useAppDispatch } from '../../store/store';
import Chat from '../Chat/Chat';

interface Props {
    product: IDigitalHealthProfile | undefined
}

export default function DiagnosticsChat({ product }: Props) {
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (product?.conversation_id) dispatch(setCurrentConversation({
            conversation_id: product.conversation_id,
            conversation_status: product?.conversation_status,
            conversation_title: product?.conversation_title,
            participants: []
        }))

        return () => {
            dispatch(clearChat())
        }
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Chat
            hideAssignBtn={true}
            chatBodyStyle={{ height: "calc(90vh - 500px)" }}
            style={{
                "border": "1px solid #dbdfea",
                "borderRadius": "0px",
                "width": "auto"
            }}
        />
    )
}
